import { defineMessages } from 'react-intl-next';

export default defineMessages({
	noDateSet: {
		id: 'date-range-picker.date-range.no-date-set',
		defaultMessage: 'No date set',
		description: 'Message to show when no date is set',
	},
});
